import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FileUploader} from './file-uploader';
import Action from 'components/organisms/players-csv/upload-players-csv/actions';

class FileDataReceiver extends Component {
    handleUploadedFiles(files) {
        const {dispatch} = this.props;
        const [file] = files;
        const fileReader = new FileReader();

        dispatch(Action.do('setDropzoneIsLoading'));

        fileReader.onloadend = function (data) {
            const {
                currentTarget: {result},
            } = data;

            dispatch(Action.do('processFileData', result));
        };

        fileReader.readAsText(file);
    }

    render() {
        const {dispatch, playersDropzone} = this.props;

        return (
            <FileUploader
                dispatch={dispatch}
                isLoading={playersDropzone.loading}
                handleUploadedFiles={::this.handleUploadedFiles}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {playersDropzone} = state;

    return {playersDropzone};
}

export default connect(mapStatesToProps)(FileDataReceiver);
